import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["title"];
import { CardEnum } from "@/modules/match/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    card: null,
    size: {
      default: 'medium'
    }
  },
  setup(__props) {
    const props = __props;
    const cardClassMap = ref({
      [CardEnum.YELLOW]: 'bg-yellow-300',
      [CardEnum.YELLOW_RED]: 'bg-yellow-300',
      [CardEnum.RED]: 'bg-red-600'
    });
    const cardClass = ref(cardClassMap.value[props.card]);
    const sizeClassMap = ref({
      medium: 'h-4 w-[14px]',
      large: 'h-8 w-[28px]'
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["inline-flex rounded overflow-hidden", {
          [sizeClassMap.value[__props.size]]: true
        }]),
        title: _ctx.$t(__props.card)
      }, [_createElementVNode("div", {
        class: _normalizeClass(["grow h-full", cardClass.value])
      }, null, 2), __props.card === _unref(CardEnum).YELLOW_RED ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["grow h-full", cardClassMap.value[_unref(CardEnum).RED]])
      }, null, 2)) : _createCommentVNode("", true)], 10, _hoisted_1);
    };
  }
});